import { createI18n } from 'vue-i18n'
import da from './locales/da.json'
import en from './locales/en.json'
import es from './locales/es.json'

export const SUPPORTED = ['da', 'en', 'es'] as const
export type Locale = (typeof SUPPORTED)[number]
const STORAGE_KEY = 'lang'

function isSupported(v: string): v is Locale {
  return (SUPPORTED as readonly string[]).includes(v)
}

// Husk brugerens valg; ellers gæt ud fra browsersproget; ellers dansk.
function detectLocale(): Locale {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved && isSupported(saved)) return saved
  const nav = (navigator.language || 'da').slice(0, 2).toLowerCase()
  return isSupported(nav) ? nav : 'da'
}

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: detectLocale(),
  fallbackLocale: 'da',
  messages: { da, en, es },
})

export function setLocale(locale: Locale): void {
  i18n.global.locale.value = locale
  localStorage.setItem(STORAGE_KEY, locale)
  document.documentElement.lang = locale
}

// Sæt <html lang> til det aktive sprog ved opstart (så også servere/SEO ser det rigtige).
document.documentElement.lang = i18n.global.locale.value

// Til brug i .ts-filer uden for komponenter (composables, api-fejlbeskeder).
export const t = i18n.global.t
